import React from 'react';
import { View, TouchableOpacity, Image, Text } from 'react-native';
import { styles } from './components/AppStyles'; // Import styles from AppStyles.js

const BottomNavBar = ({ navigation, current }) => {
  return (
      <View style={styles.navBarContainer}>
          <TouchableOpacity
              onPress={() => navigation.navigate('Home')}
              disabled={current === 'Home'}
              style={current === 'Home' ? styles.navButtonDisabled : styles.navButton}
          >
              <Image style={styles.navIcon} source={require('./assets/icon_decks.png')} />
              <Text style={styles.navIconText}>Decks</Text>
          </TouchableOpacity>
          
          <TouchableOpacity
              onPress={() => navigation.navigate('Search')}
              disabled={current === 'Search'}
              style={current === 'Search' ? styles.navButtonDisabled : styles.navButton}
          >
              <Image style={styles.navIcon} source={require('./assets/icon_search.png')} />
              <Text style={styles.navIconText}>Search</Text>
          </TouchableOpacity>
      </View>
  );
};

export default BottomNavBar;